import {
    fontWeightBold,
    playTransitionCubicEaseInOut,
    regularBlack,
    regularWhite,
    SlashTiming,
} from '@ui-components/design-tokens';
import PlayText, { SIZE } from '@ui-components/typography/PlayText';
import { PlayTextStyles } from '@ui-components/typography/PlayText/PlayText.styles';
import styled, { css, keyframes } from 'styled-components';
import ExternalLink from '../ExternalLink/ExternalLink';

export const ErrorHeadline = styled.h2.attrs({ size: SIZE.XLARGE })`
    ${PlayTextStyles}
    color: ${regularWhite};
`;

export const RightsLink = styled(ExternalLink)`
    font-weight: ${fontWeightBold};
    display: flex;
    line-height: 1;
    align-items: center;
`;

export const Description = styled(PlayText)`
    display: block;
    margin-top: 10px;
`;

export const ErrorContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
`;

const fade = keyframes`
    0% {
        opacity: 0;
    }
    80% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

const fadeSlash = keyframes`
    0% {
        opacity: 1;
        
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
 

    }
`;

const slashAnimation = keyframes`
    from {
        transform: scale(0.1);
    }
    to {
        transform: scale(10);
    }
`;
export const SlashAnimationWrapper = styled.div`
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
    opacity: 1;
    display: flex;
    align-items: center;
    z-index: 902;
    animation: ${fadeSlash} ${`${SlashTiming}ms`} linear forwards;
    pointer-events: none;
`;

export const SlashAnimation = styled.svg`
    animation: ${slashAnimation} ${`${SlashTiming * 0.75}ms`} cubic-bezier(0.835, 0.025, 0.795, 0.035)
        forwards;
    backface-visibility: hidden;
    will-change: transform;
    width: 100%;
    height: 100%;
    fill: ${regularBlack};

    @media screen and (prefers-reduced-motion: reduce) {
        animation: none;
        transform: scale(10);
    }
`;

export const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 900;
    width: 100%;
    height: 100%;
    opacity: 0;
    background-color: ${regularBlack};

    ${(props) => props.hidden && `display: none;`}

    ${(props) =>
        !props.hidden &&
        css`
            opacity: 1;
            animation: ${fade} ${`${SlashTiming * 0.85}ms`} ${playTransitionCubicEaseInOut};
        `}
`;
